export const TUIRoomErrorCode = {
  INVALID_PARAM_ERROR: -1000,
  LOGIN_ERROR: -1001,
  LOGOUT_ERROR: -1002,
  NOT_LOGIN: -1003,
  TIM_ERROR: -1004,
  TRTC_NOT_EXIST_ERROR: -1005,
  ROOM_EXISTED: -1006,
  SDK_NOT_READY: -1007,
  CREATE_GROUP_ERROR: -1008,
  JOIN_GROUP_ERROR: -1009,
  QUIT_GROUP_ERROR: -1010,
  DISMISS_GROUP_ERROR: -1011,
  SEND_MESSAGE_ERROR: -1012,
  SEND_CUSTOM_MESSAGE_ERROR: -1013,
  CREATE_ROOM_ERROR: -1014,
  DESTROY_ROOM_ERROR: -1015,
  ENTER_ROOM_ERROR: -1016,
  EXIT_ROOM_ERROR: -1017,
  SET_ROOM_CONTROL_CONFIG_ERROR: -1018,
  GROUP_NOT_EXIST_ERROR: -1019,
  CHANGE_ALL_MIC_MUTE_ERROR: -1020,
  CHANGE_GROUP_OWNER: -1021,
  WEB_SCREEN_SHARE_SYSTEM_DENY: -1022,
  WEB_SCREEN_SHARE_USER_DENY: -1023,
  WEB_SCREEN_SHARE_UNKNOWN: -1024,
  GET_GROUP_MEMBER_PROFILE_ERROR: -1025,
  CHANGE_ALL_CAMERA_MUTE_ERROR: -1026,
  GET_GROUP_MEMBER_LIST_ERROR: -1027,

  ROOM_BEEN_DESTROYED: -1997,
  NO_PRIVILEGE: -1998,
  UNKNOWN_ERROR: -1999,

  CALLING_ROLL: -2000,
  NOT_CALL_ROLL: -2001,
  START_CALL_ROLL_ERROR: -2002,
  STOP_CALL_ROLL_ERROR: -2003,
  SEND_SPEECH_APPLICATION_EORRO: -2004,

  TS_INVITE_ERROR: -2010,
  TS_CMD_ERROR: -2011,
};

export const TUIRoomErrorMessage = {
  INVALID_PARAM_ERROR: '无效参数',
  LOGIN_ERROR: '登录失败',
  LOGOUT_ERROR: '登出失败',
  LOGOUT_TIM_ERROR: '退出 TIM 失败',
  LOGOUT_TRTC_ERROR: '退出 TRTC 房间失败',
  NOT_LOGIN: '未登录',
  TRTC_NOT_EXIST_ERROR: 'TRTC 实例未创建',
  ROOM_EXISTED: '房间已存在',
  SDK_NOT_READY: 'SDK 初始化未完成',
  CREATE_GROUP_ERROR: '创建群组失败',
  JOIN_GROUP_ERROR: '加入群组失败',
  QUIT_GROUP_ERROR: '退出群组失败',
  DISMISS_GROUP_ERROR: '解散群组失败',
  SEND_MESSAGE_ERROR: '发送文本消息失败',
  SEND_CUSTOM_MESSAGE_ERROR: '发送自定义消息失败',
  CREATE_ROOM_ERROR: '创建房间失败',
  DESTROY_ROOM_ERROR: '销毁房间失败',
  ENTER_ROOM_ERROR: '进入房间失败',
  EXIT_ROOM_ERROR: '退出房间失败',
  ROOM_BEEN_DESTROYED: '房间实例已被销毁',
  SET_ROOM_CONTROL_CONFIG_ERROR: '设置房间控制配置失败',
  GROUP_NOT_EXIST_ERROR: '群组不存在',
  CHANGE_ALL_MIC_MUTE_ERROR: '修改全员禁麦克风状态失败',
  CHANGE_ALL_CAMERA_MUTE_ERROR: '修改全员禁画状态失败',
  CHANGE_GROUP_OWNER: '转移群失败',
  WEB_SCREEN_SHARE_SYSTEM_DENY: '系统禁止当前浏览器获取屏幕内容',
  WEB_SCREEN_SHARE_USER_DENY: '用户拒绝/取消屏幕分享',
  WEB_SCREEN_SHARE_UNKNOWN: '屏幕分享遇到未知错误',
  GET_GROUP_MEMBER_PROFILE_ERROR: '获取群成员信息失败',
  GET_GROUP_MEMBER_LIST_ERROR: '获取群成员列表失败',
  NO_PRIVILEGE: '无权限',
  UNKNOWN_ERROR: '未知错误',

  CALLING_ROLL: '正在点名中',
  NOT_CALL_ROLL: '尚未开始点名',
  START_CALL_ROLL_ERROR: '开始点名失败',
  STOP_CALL_ROLL_ERROR: '结束点名失败',
  SEND_SPEECH_APPLICATION_EORRO: '申请发言失败',

  TS_INVITE_ERROR: '邀请信令已在流程中，请不要重复邀请',
  TS_CMD_ERROR: '本次响应操作无对应邀请事件信令',
};

export const TSignalingConfig = {
  timeout: 0,
};

export const TIM_ROOM_PREFIX = '';
